import React, { useContext, useRef, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { channels_dictionary } from '../../static/channels_dictionary';
import { Button } from '../UiKit/Button';
import { Preview } from '../UiKit/Preview';
import { Txt } from '../UiKit/Txt';
import Channel from '../UiKit/Channel';
import { Background } from '../UiKit/Background';
import { getTypeFromChannels } from '../utilsDesign';
import './definition.css';


export const Definition = React.memo(({ id, design }) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;






  return (<>
    <div className="x_edu_content_title">

      <div className={`x_definition_items_container x_definition_items_container--${design.split.length}`}>
        



          {Array.isArray(design.split) && design.split.map((item, idx) => (
            <DefinitionItem
              key={idx}
              item={item}
              design={design}
            />
          ))}




        <div className="x_edu_content_description x_edu_definition_description"
        style={{
          '--defWidth': `calc(${100 / design.split.length}% - 3em)`,
        }}
        >
          <h2>
            {$ui(`definition_${design.split.length}`)} {$ui('definition_title')}
          </h2>
          <Txt className="x_edu_content_description">
            {$ui(`definition_${design.split.length}_description`)}
          </Txt>
        </div>


      
      </div>
    </div>
  </>
  )
})


const DefinitionItem = React.memo(({ item, design, style = {} }) => {


  const getCentersAndGates = (channelIds = []) => {

    const channelArray = Array.isArray(channelIds) ? channelIds : [channelIds];

    const allCenters = [];
    const allGates = [];

    channelArray.forEach(channelId => {
      const channel = channels_dictionary.filter(one => one.id === channelId)[0];
      if (channel) {
        allCenters.push(...channel.centers);
        allGates.push(...channel.gates);
      }
    });

    // Remove duplicates
    const uniqueCenters = [...new Set(allCenters)];
    const uniqueGates = [...new Set(allGates)];

    return { uniqueCenters, uniqueGates };
  }

  const handleChannelHover = (channelIds = []) => {
    // console.log('channelIds = ', channelIds);
    if (channelIds.length > 0) {
      // Handle both single channel ID (string) and array of channel IDs

      const { uniqueCenters, uniqueGates } = getCentersAndGates(channelIds);

      setCenters(uniqueCenters);
      setGates(uniqueGates);
    } else {
      setCenters([]);
      setGates([]);
    }
  };


  const [centers, setCenters] = useState([...getCentersAndGates(item).uniqueCenters]);
  const [gates, setGates] = useState([...getCentersAndGates(item).uniqueGates]);

  const bodyContainer = useRef();

  return (
    <div
      className={`x_edu_definition x_edu_definition--${design.split.length}`}
      style={{
        '--split': design.split.length,
        '--defWidth': `calc(${100 / design.split.length}% - 3em)`,
        '--defMobile': `calc(${100 / design.split.length}% - 3em)`,
        ...style,
      }}
    >
      <Background
        className="x_edu_definition_bg"
        design={{ type: getTypeFromChannels(item) }}
      />

      <div ref={bodyContainer} className="_fv x_edu_definition_preview">
        <Preview
          GroupMe={false}
          arrowsP={false}
          aura={false}
          design={design}
          highlighted={centers}
          highlightedGate={gates}
          parentContainer={bodyContainer}
        />
      </div>

      <div className="_f _fgap06 _fc _fwrap x_edu_definition_channels">
        {/* {item.map((channel) => channel).join(', ')} */}
        {item.map((channel) => <div
          className="x_edu_channel_item"
          key={channel}
          onMouseOver={() => handleChannelHover([channel])}
          onMouseOut={() => {
            setCenters([...getCentersAndGates(item).uniqueCenters]);
            setGates([...getCentersAndGates(item).uniqueGates]);
          }}
        >
          <Channel
            channels={channels_dictionary.filter(one => one.id === channel)[0]?.types}
            showAdvancedInfo={false}
            showActivations={false}
            hideLabel={true}
            hideTitle={true}
            hideTitleMobile={true}
            id={channel}
            design={design}
            // gates={[...item.split('-')]}
            view="column"
            // hideNumbers={true}
            videos={false}
            description={false}
            types={channels_dictionary.filter(one => one.id === channel)[0]?.types}
            className="x_edu_content_channel"
            visual="min"
          />
        </div>)}
      </div>
    </div>
  )
})